(() => {
  const ATTR = 'data-gd-floating-positioned';
  let raf = 0;

  const roots = () => {
    const found = [document];
    const walk = (root) => {
      root.querySelectorAll('*').forEach((node) => {
        if (node.shadowRoot && !found.includes(node.shadowRoot)) {
          found.push(node.shadowRoot);
          walk(node.shadowRoot);
        }
      });
    };
    walk(document);
    return found;
  };

  const textOf = (el) => [
    el.textContent,
    el.getAttribute?.('aria-label'),
    el.getAttribute?.('title'),
    el.getAttribute?.('data-testid'),
    el.getAttribute?.('src')
  ].filter(Boolean).join(' ').trim();

  const isInlineTextWhatsappLink = (el) =>
    el instanceof HTMLAnchorElement &&
    !!el.closest('.text-block, .rte-formatter');

  const resetAccidentalWhatsappLink = (el) => {
    if (!isInlineTextWhatsappLink(el) || el.getAttribute(ATTR) !== 'whatsapp') return;
    ['position', 'right', 'left', 'top', 'bottom', 'z-index'].forEach((prop) => {
      el.style.removeProperty(prop);
    });
    el.removeAttribute(ATTR);
  };

  const compactFixedAncestor = (el) => {
    let node = el;
    let best = null;
    while (node && node !== document.documentElement) {
      if (node instanceof HTMLElement) {
        const style = getComputedStyle(node);
        if (style.position === 'fixed') {
          const rect = node.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0 && rect.width <= 260 && rect.height <= 180) {
            best = node;
          }
        }
      }
      node = node.parentElement;
    }
    return best;
  };

  const locate = (kind) => {
    const candidates = [];
    roots().forEach((root) => {
      const selector = kind === 'gift'
        ? 'button, a, [role="button"], iframe, [aria-label], [title]'
        : 'a[href*="wa.me"], a[href*="whatsapp.com"], iframe[src*="whatsapp"], [aria-label*="whatsapp" i], [title*="whatsapp" i]';
      root.querySelectorAll(selector).forEach((el) => {
        if (kind === 'whatsapp' && isInlineTextWhatsappLink(el)) {
          resetAccidentalWhatsappLink(el);
          return;
        }

        const value = textOf(el);
        const matches = kind === 'gift'
          ? /(^|\s)regalos!?($|\s)/i.test(value) || /essential[-_ ]?loyalty|loyalty.*gift/i.test(value)
          : /whatsapp|wa\.me/i.test(value);
        if (matches) candidates.push(el);
      });
    });

    const fixed = candidates
      .map(compactFixedAncestor)
      .filter((el) => el instanceof HTMLElement)
      .sort((a, b) => {
        const ar = a.getBoundingClientRect();
        const br = b.getBoundingClientRect();
        const af = getComputedStyle(a).position === 'fixed' ? 0 : 1;
        const bf = getComputedStyle(b).position === 'fixed' ? 0 : 1;
        return af - bf || (ar.width * ar.height) - (br.width * br.height);
      });

    return fixed[0] || null;
  };

  const place = (el, kind, whatsapp) => {
    if (!el) return;
    const mobile = matchMedia('(max-width: 749px)').matches;
    let right = mobile ? 16 : 24;
    let bottom = kind === 'gift' ? (mobile ? 16 : 24) : (mobile ? 76 : 24);

    if (kind === 'gift' && !mobile && whatsapp) {
      const whatsappRect = whatsapp.getBoundingClientRect();
      const giftRect = el.getBoundingClientRect();
      const gap = 24;
      right = Math.max(24, Math.round(innerWidth - whatsappRect.left + gap));
      const whatsappBottom = Math.max(0, innerHeight - whatsappRect.bottom);
      bottom = whatsappBottom + Math.max(0, Math.round((whatsappRect.height - giftRect.height) / 2)) + 7;
    }

    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('right', right + 'px', 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('bottom', 'calc(' + bottom + 'px + env(safe-area-inset-bottom, 0px))', 'important');
    el.style.setProperty('z-index', kind === 'gift' ? '999' : '1000', 'important');
    el.setAttribute(ATTR, kind);
  };

  const apply = () => {
    raf = 0;
    const whatsapp = locate('whatsapp');
    const gift = locate('gift');
    place(whatsapp, 'whatsapp');
    place(gift, 'gift', whatsapp);
  };

  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(apply);
  };

  const start = () => {
    apply();
    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    addEventListener('resize', schedule, { passive: true });
    setTimeout(apply, 1000);
    setTimeout(apply, 3000);
    setTimeout(apply, 7000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();